import { STOCK_MAGNIFIER } from '@diamond/shared/decimal-util-web';
import type {
  FreeGoodsCalculationParams,
  FreeGoodsCalculationResult,
} from '@diamond/shared/types';

export const calculateFreeGoods = ({
  userQuantity,
  minimumOrderQuantity,
  quantityFreeGoods,
  isAppliesInMultiples,
}: FreeGoodsCalculationParams): FreeGoodsCalculationResult => {
  if (!isAppliesInMultiples) {
    // Simple case: user gets free goods if they meet minimum
    const multiplier = userQuantity >= minimumOrderQuantity ? 1 : 0;
    const calculatedFreeQty = multiplier * quantityFreeGoods;

    return {
      multiplier,
      calculatedFreeQty,
      totalFreeQtyUI: calculatedFreeQty / STOCK_MAGNIFIER,
    };
  }

  // Multiplier case: calculate how many times promo applies
  const multiplier = Math.floor(userQuantity / minimumOrderQuantity);
  const calculatedFreeQty = multiplier * quantityFreeGoods;

  return {
    multiplier,
    calculatedFreeQty,
    totalFreeQtyUI: calculatedFreeQty / STOCK_MAGNIFIER,
  };
};
